
// Default MOMENT JS date display format
export const defaultDateTimeFormat = 'D MMM YYYY HH:mm';
export const defaultDateFormat = 'D MMM YYYY';

// Format used by the backend database (MySQL datetime)
export const databaseDateTimeFormat = 'YYYY-MM-DD HH:mm:ss';
// Format used by HTML date inputs and as a date-only database value
export const databaseDateFormat = 'YYYY-MM-DD';
